import React, { useRef } from 'react'
import { Link } from 'gatsby'
import useProducts from '../hooks/useProducts'
import useRankings from '../hooks/useRankings'
import * as b from './bootstrap.module.css'
import Icon from "../components/icon.tsx"
import Translate from './translate'
import useMedia from "../hooks/useMedia";
import resolveUrl from '../utils/urls/resolve-url'
import RankingItem from './items/ranking-item'

const SmallRanking = ({ rankingLists }) => rankingLists.map(([group, items], i) => (
  <aside key={i} className={[b.card, b.mt4, 'blog-ranking-br'].join(' ')}>
    <div className={['blog-ranking', b.pbLg5].join(' ')}>
      <div className={[b.dFlex, b.alignItemsCenter, b.mb3].join(' ')}>
        <div className={["icon-box-acc", b.mr3].join(" ")}>
          <Translate tKey="account-ranking-url">{(text) => group.name.startsWith('ranking-kont-dla-dzieci') ? <Icon size={40} icon="Junior-account" className='icon-width' /> : group.name.startsWith('ranking-kont-oszczednosciowych') ? <Icon size={40} icon="Piggy-bank" className='icon-width' /> : group.name.startsWith(`${text}`) ? <Icon size={40} icon="Bank-account" className='icon-width' /> : ''}</Translate>
          <Translate tKey="payday-loans-ranking-url">{(text) => group.url.startsWith(`${text}`) ? <Icon size={40} icon="Loans" className='icon-width' /> : ''}</Translate>
          <Translate tKey="installment-loan-ranking-url">{(text) => group.url.startsWith(`${text}`) ? <Icon size={40} icon="Installment-loan" className='icon-width' /> : ''}</Translate>
          <Translate tKey="cash-credit-ranking-url">{(text) => group.url.startsWith(`${text}`) ? <Icon size={40} icon="Cash-loan" className='icon-width' /> : ''}</Translate>
          <Translate tKey="credit-card-ranking-url">{(text) => group.name.startsWith(`${text}`) ? <Icon size={40} icon="Credit-cards" className='icon-width' /> : ''}</Translate>
          <Translate tKey="Car ranking">{(text) => group.name.includes(`${text}`) ? <Icon size={40} icon="Car-loan" className='icon-width' /> : ''}</Translate>
          <Translate tKey="Mortgage ranking">{(text) => group.name.includes(`${text}`) ? <Icon size={40} icon="Mortgage" className='icon-width' /> : ''}</Translate>
          <Translate tKey="Consolidation ranking">{(text) => group.name.includes(`${text}`) ? <Icon size={40} icon="Consolidation-loan" className='icon-width' /> : ''}</Translate>
          <Translate tKey="Nonbank cards ranking">{(text) => group.name.includes(`${text}`) ? <Icon size={40} icon="Non-bank-cards" className='icon-width' /> : ''}</Translate>
          <Translate tKey="Installment loan ranking">{(text) => group.name.includes(`${text}`) ? <Icon size={40} icon="Installment-loan" className='icon-width' /> : ''}</Translate>
          <Translate tKey="Bank deposit rankings">{(text) => group.name.includes(`${text}`) ? <Icon size={40} icon="Investment" className='icon-width' /> : ''}</Translate>
        </div>
        <span className={['font-size-24', b.textWhite].join(' ')}>{group.name}</span>
      </div>
      <div className={[b.row].join(' ')}>
        {
          items.slice(0, 3).map((item, j) => <RankingItem key={j} item={item} i={j + 1} ranking="item" />)
        }
      </div>
    </div>
    <div className={[b.p3, b.pLg5, b.textCenter, b.alignItemsCenter, b.justifyContentCenter].join(' ')}>
      <span className={['blackToWhite', 'font-size-24'].join(' ')}>Szukasz pełnego rankingu?</span>
      <div className={['blackToWhite'].join(' ')}>Sprawdź {items.length} ofert i wybierz taką, jaka Ci pasuje</div>
      <Link to={resolveUrl(group.prefix_url, group.url)} className={[b.btn, 'btn-light', 'btn-normal', 'button-256', b.mxAuto, 'blog-ranking-btn', b.fontWeightNormal, 'blueToWhite', b.mt3, b.mtLg4].join(' ')}>
        <Translate tKey="View full ranking" />
      </Link>
    </div>
  </aside>
))

const ColumnRanking = ({ rankingLists }) => {
  const getImage = (i) => {
    switch (i) {
      case 0:
        return <Icon size={60} icon="Piggy-bank" />
      case 1:
        return <Icon size={60} icon="Consolidation-loan" />
      case 2:
        return <Icon size={60} icon="Firm-folder" />
      case 3:
        return <Icon size={60} icon="Mortgage" />
      case 4:
        return <Icon size={60} icon="Bank-account" />
      case 5:
        return <Icon size={60} icon="Cash-loan" />
      case 6:
        return <Icon size={60} icon="Installment-loan" />
      case 7:
        return <Icon size={60} icon="Loans" />
      default:
        return null;
    }
  }

  return (
    <section className={['ranking-section-column', b.container, b.my5].join(' ')}>
      <h2 className="title">
        <Translate tKey="Financial rankings" />
      </h2>
      <p className={['ranking-section-column-desc', b.my3, b.myLg4, b.mbLg5, 'blueToGray'].join(' ')}><Translate tKey="Checkout the latest financial rankings" /></p>
      <div className={b.row}>
        {
          rankingLists.map(([group, items], i) => (
            <div key={i} className={['col-xxl-3', b.colLg4, b.colMd6, b.mb3, b.mbLg5].join(' ')}>
              <article className={['ranking-column', b.card].join(' ')}>
                <span className={['ranking-column-title', b.mb3].join(' ')}>
                  <Link to={resolveUrl(group.prefix_url, group.url)} className={[b.dFlex, b.alignItemsCenter].join(' ')}>
                    {getImage(i)}
                    <span className={[b.ml3,'tp-name'].join(' ')}>
                      {group.name}
                    </span>
                  </Link>
                </span>
                {
                  items.map((item, j) => <RankingItem key={j} item={item} i={j + 1} ranking="404" />)
                }
              </article>
            </div>
          ))
        }
      </div>
    </section>
  )
}
const PageNotFoundRanking = ({ rankingLists }) => {
  const getImage = (i) => {
    switch (i) {
      case 0:
        return <Icon size={40} icon="Loans" />
      case 1:
        return <Icon size={40} icon="Installment-loan" />
      case 2:
        return <Icon size={40} icon="Firm-folder" />
      case 3:
        return <Icon size={40} icon="Cash-loan" />
      default:
        return null;
    }
  }

  return (
    <section className={['ranking-section-column', b.container, b.my5, 'ranking-404-relative'].join(' ')}>
      <div className={b.row}>
        {
          rankingLists.map(([group, items], i) => (
            <div key={i} className={['col-xxl-4', b.colLg6, b.mb5].join(' ')}>
              <article className={['ranking-column', b.card].join(' ')}>
                <span className={['ranking-column-title', b.mb3].join(' ')}>
                  <Link to={resolveUrl(group.prefix_url, group.url)} className={[b.dFlex, b.alignItemsCenter].join(' ')}>
                    {getImage(i)}
                    <span className={[b.ml3,'tp-name'].join(' ')}>
                      {group.name}
                    </span>
                  </Link>
                </span>
                {
                  items.map((item, j) => <RankingItem key={j} item={item} i={j + 1} ranking="404" />)
                }
                <Link to={resolveUrl(group.prefix_url, group.url)} className={[b.btn, "btn-light", "btn-normal", "blueToWhite"].join(" ")}>
                  <Translate tKey="View full ranking" />
                </Link>
              </article>
            </div>
          ))
        }
      </div>
    </section>
  )
}

const OtherRanking = ({ rankingLists, settings }) => {
  const isMobileResolution = useMedia(['(max-width: 992px)'], [true], false);
  
  return (
    <section>
      <div>
        {
          rankingLists.map(([groupName, items], i) => (
            <div key={i} className={`post-wrapper post-wrapper-row blackToGray`}>
              {
                items.length
                  ? items.map((item, i) => <RankingItem key={i} item={item} i={i + 1} settings={settings} isMobileResolution={isMobileResolution} />)
                  : <Translate tKey="No products were found" />
              }
            </div>
          ))
        }
      </div>
    </section>
  )
}

const RankingWidget = ({ types, theme, limit, settings }) => {
  const settingsRef = useRef({
    types: 'all',
    subtypes: settings?.subtypes?.firm && settings.subtypes,
    input: settings.types === 'credits' ? { 
      amount: 30_000, 
      time: 24 
    } : { 
      amount: 1000, 
      time: settings?.subtypes?.firm === 1 ? 30 : 1
    },
    filters: { all: { withoutCalculator: true }, }
  });

  const { objectLists } = useProducts(settingsRef.current);
  const { rankingLists } = useRankings({ lists: objectLists, types, limit });

  if (!rankingLists.length) {
    return null
  }

  return theme === 'PageNotFound' ? <PageNotFoundRanking rankingLists={rankingLists} /> : theme === 'widget' ?
    <SmallRanking rankingLists={rankingLists} /> :
    theme === 'column' ?
      <ColumnRanking rankingLists={rankingLists} /> :
      <OtherRanking rankingLists={rankingLists} settings={settings} />
}

RankingWidget.defaultProps = {
  limit: 3,
  theme: 'widget',
  settings: {},
}

export default RankingWidget